import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { countries } from '../../model/country-data-store';
import { timeZoneToCountry } from '../../model/time-zone-mapping';
import { GlobalService } from '../../service/global.service';
import { HttpService } from '../../service/http.service';
import { emailOtpSend, LOGIN, VERIFY_OTP } from '../../service/payload';
import { ToastrService } from 'ngx-toastr';
import { CountryISO, NgxIntlTelInputModule, SearchCountryField } from 'ngx-intl-tel-input';
import { interval, Subscription } from 'rxjs';


@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgxIntlTelInputModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {


  isLoginPopup: boolean = true;
  isForgetPassPopup: boolean = false;
  isOtpPopup: boolean = false;

  @Output() close = new EventEmitter<boolean>();
  @Input() loginPopuptype: any;
  checkBoc: boolean = false;
  mobileNumber: number;
  otp: string[] = ['', '', '', ''];
  showOtpFields: boolean = false;
  selectedCountryCode = '+91';
  selectedDialCode = '';
  // dialCode = '+91';
  isMobileValid = false;
  currentTimeZone: string = '';

  country = countries;

  email: string = '';
  emailOtp: string[] = ['', '', '', ''];
  showEmailOtpField: boolean = false;
  showEmailLoginBtn: boolean = true;
  //Mobile Flag
  phoneForm: FormGroup;

  emailForm: FormGroup;

  userIdForOTP: any;

  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;

  preferredCountries: CountryISO[] = [CountryISO.India];

  constructor(private http: HttpService, private toastr: ToastrService, public gS: GlobalService, private fb: FormBuilder) {
    this.gS.userName = localStorage.getItem('userfullname');

    this.phoneForm = this.fb.group({
      phone: [undefined, [Validators.required]],
      termsAccepted: [false, Validators.requiredTrue]
    });

    this.emailForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      termsAccepted: [false, Validators.requiredTrue]
    });
  }


  ngOnInit() {


    console.log(this.loginPopuptype);
  }



  closePopup() {
    this.close.emit(false);
  }

  forgetPassPopup() {
    this.isLoginPopup = false;
    this.isForgetPassPopup = true;
    this.isOtpPopup = false;
  }

  validateAndRequestOtp() {
    if (this.checkBoc) {
      this.requestOtp();
    } else {
      this.toastr.warning('Please agree to terms and conditions.', 'Warning');
    }
  }

  resendOtp() {
    this.requestOtp();
  }

  requestOtp() {
    console.log("Login Clicked");
    console.log("Selected Country Code:", this.selectedCountryCode);
    console.log("Entered Mobile Number:", this.mobileNumber);
    console.log("Current Timezone:", this.currentTimeZone);



    if (this.mobileNumber) {
      let payload: LOGIN = {
        appVersion: this.gS?.appVersion,
        countryCode: this.selectedCountryCode,
        customerMobile: this.mobileNumber,
        notificationId: this.gS?.notificationId,
        platformType: this.gS?.platformType,
        timeZone: this.gS?.timeZone,
        projectId: this.gS?.projectId
      }

      this.http.userMobileLogin(payload).then((res: any) => {
        if (res?.status == 'fail') {
          this.showOtpFields = false;
        } else {
          this.toastr.success('OTP sent to given mobile number');
          this.gS.LoggedUserData = res?.data;
          this.showOtpFields = true;
        }
      });
    }
  }

  submitLogin() {
    console.log("Submit Clicked");
    console.log("Entered OTP:", this.otp.join(''));
    console.log("Mobile Number:", this.selectedCountryCode + " " + this.mobileNumber);
    console.log("Timezone:", this.currentTimeZone);

    let payload: VERIFY_OTP = {
      userId: this.gS.LoggedUserData?.id,
      otp: this.otp.join('')
    }

    this.http.verifyOtp(payload).then(async (res: any) => {
      console.log(res);
      if (res?.status == "success") {

        this.gS.userName = res?.data.name;
        let userData = res?.data;
        this.gS.userFullName = res?.data.name;
        localStorage.setItem('userData', JSON.stringify(userData));
        localStorage.setItem('userfullname', JSON.stringify(this.gS.userFullName));

        this.gS.userData = this.gS.getUserDataFromStorage();

        this.gS.authTokenId = res?.data?.authToken;
        this.gS.isUserLoggedin = true;
        this.closePopup();
        location.reload();

      } else if (res?.status == "fail") {
        this.otp = ['', '', '', ''];
        this.showOtpFields = false;
        this.isLoginPopup = true;
        this.toastr.error("'Failed", "Error");
      } else {
        console.log("Unexpected response:", res);
      }
    })


  }

  submitEmailLogin() {

    console.log('Email:', this.email);

    let payload: emailOtpSend = {
      platformType: this.gS?.PlatformType,
      timeZone: this.gS?.timeZone,
      email: this.emailForm.value.email,
    }

    this.http.userLoginEmail(payload).subscribe((res: any) => {
      if (res?.status == "success") {
        console.log(res?.status);
        // this.gS.LoggedUserData = res?.data;
        this.userIdForOTP = res?.data?.id;

        this.showEmailOtpField = true;
        this.startCountdown();
      }
    });
  }


  resendOTPEmail() {
    console.log(this.emailForm.value.email);
    // return false;
    this.http.sendOTPEmail(this.userIdForOTP, this.emailForm.value.email).subscribe((data: any) => {
      this.startCountdown();
    });
  }


  submitEmailOtp() {

    console.log(this.emailOtp.join());
    let payload: VERIFY_OTP = {
      userId: this.userIdForOTP,
      otp: this.emailOtp.join('')
    }

    this.http.verifyEmail(payload).then(async (res: any) => {
      console.log(res, 'customerdata');
      if (res?.status == "success") {

        this.gS.userName = res?.data.name;
        let userData = res?.data;
        this.gS.userFullName = res?.data.name;
        localStorage.setItem('userData', JSON.stringify(userData));
        localStorage.setItem('userfullname', JSON.stringify(this.gS.userFullName));

        this.gS.userData = this.gS.getUserDataFromStorage();

        this.gS.authTokenId = res?.data?.authToken;
        this.gS.isUserLoggedin = true;
        this.closePopup();
        location.reload();

      } else if (res?.status == "fail") {
        this.otp = ['', '', '', ''];
        this.showOtpFields = false;
        this.isLoginPopup = true;
        this.toastr.error("'Failed", "Error");
      } else {
        console.log("Unexpected response:", res);
      }
    })

  }

  otpPopup() { }



  validateMobileNumber(event: any) {
    if (this.selectedCountryCode === "+91") {
      let input = event.target.value.toString();
      if (input.length > 10) {
        this.mobileNumber = Number(input.slice(0, 10));
      }
    }
  }



  //Mobile No Validation

  countdown: number = 0;
  showResend: boolean = false;
  private timerSubscription?: Subscription;

  requestOtpagain() {
    this.otp = ['', '', '', ''];
    this.requestOtpFlag();
  }

  // Go back from the OTP screen to the mobile-number entry, resetting OTP state
  changeNumber() {
    this.showOtpFields = false;
    this.otp = ['', '', '', ''];
    this.timerSubscription?.unsubscribe();
    this.countdown = 0;
    this.showResend = false;
  }


  requestOtpFlag() {
    if (this.phoneForm.valid) {
      const phoneValue = this.phoneForm.value.phone;
      // const cleanedPhoneNumber = phoneValue?.number.replace(/\s+/g, '');  
      const cleanedPhoneNumber = phoneValue?.e164Number;
      console.log('Dial Code:', phoneValue?.dialCode);
      console.log('Mobile Number:', cleanedPhoneNumber);
      if (phoneValue) {
        let payload: LOGIN = {
          appVersion: this.gS?.appVersion,
          countryCode: phoneValue?.dialCode,
          // customerMobile: cleanedPhoneNumber,
          customerMobile: phoneValue.e164Number.replace(phoneValue.dialCode, ''),
          notificationId: this.gS?.notificationId,
          platformType: this.gS?.platformType,
          timeZone: this.gS?.timeZone,
          projectId: this.gS?.projectId
        }

        this.http.userMobileLogin(payload).then((res: any) => {
          if (res?.status == 'fail') {
            this.showOtpFields = false;
          } else {
            this.toastr.success('OTP sent to given mobile number');
            this.gS.LoggedUserData = res?.data;
            this.showOtpFields = true;
            this.startCountdown();
          }
        });
      }
    } else {
      this.toastr.error('Please enter valid mobile number');
    }

  }




  startCountdown(): void {
    this.countdown = 10;
    this.showResend = false;

    this.timerSubscription?.unsubscribe();

    this.timerSubscription = interval(1000).subscribe(() => {
      this.countdown--;

      if (this.countdown === 0) {
        this.timerSubscription?.unsubscribe();
        this.showResend = true;
      }
    });
  }




}
